import Vue from 'vue';




class LoaderPalette extends Vue {

    dtPalette: any 

    constructor(){
        super()
        this.dtPalette= {
            'grey-1' : 'rgb(180,180,180)',
            'grey-2': 'rgb(200,200,200)',
            'grey-3' : 'rgb(220,220,220)',
            'grey-light-3': 'rgb(220,220,220,.4)',
            'grey-4' : 'rgb(240,240,240)',
        }
    }
}

export default LoaderPalette


// WEBPACK FOOTER //
// ./src/components/loader-palette/index.ts